export const SET_IS_WAITING = "SET_IS_WAITING";
export const SET_TOAST = "SET_TOAST";
